import Vue from "vue";
import App from "./App.vue";

import "@/plugins/common.js";
import "@/plugins/element.js";

import constant from '@/common/constant.js';
import http from "@/common/http.js";
import {util} from '@/common/comUtil.js'


Vue.prototype.$constant = constant;
Vue.prototype.$http = http;
Vue.prototype.$util = util;

Vue.config.productionTip = false;

new Vue({
    render: h => h(App)
}).$mount("#app");
